import { assertDateOnly } from "./dates.ts"
import type { DateOnly } from "./types.ts"

/** A calendar day in the business timezone, independent of the runtime timezone. */
export function londonDateOnly(now = new Date()): DateOnly {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now)
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value ?? ""
  return assertDateOnly(`${part("year")}-${part("month")}-${part("day")}`)
}

/** Calendar-month addition clamps the day to the target month's last day. */
export function addCalendarMonths(value: DateOnly, months: number): DateOnly {
  assertDateOnly(value)
  if (!Number.isInteger(months)) throw new Error("INVALID_MONTH_OFFSET")
  const [year, month, day] = value.split("-").map(Number)
  const target = new Date(Date.UTC(year, month - 1 + months, 1))
  const lastDay = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate()
  target.setUTCDate(Math.min(day, lastDay))
  return assertDateOnly(target.toISOString().slice(0, 10))
}
